// frontend/src/pages/write/writeHtmlUtils.js

// Used in sanitizeImages() and containsSanitizedImages() to detect unauthorized images
const IMAGE_PLACEHOLDER_TEXT =
  "[Image Removed – Please use the upload button.]";

// Replace unauthorized <img> tags with a placeholder span
export function sanitizeImages(html) {
  const prefix = process.env.REACT_APP_AWS_S3_IMAGE_URL;

  if (!prefix) {
    console.warn(
      "Missing REACT_APP_AWS_S3_IMAGE_URL; skipping image sanitization."
    );
    return html;
  }

  const allowedPrefix = prefix.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");

  const pattern = new RegExp(
    `<img[^>]+src=["']((?!${allowedPrefix}).*?)["'][^>]*>`,
    "g"
  );

  return html.replace(
    pattern,
    `<span class="image-placeholder">${IMAGE_PLACEHOLDER_TEXT}</span>`
  );
}

export function containsSanitizedImages(html) {
  const div = document.createElement("div");
  div.innerHTML = sanitizeImages(html);
  return !!div.querySelector(".image-placeholder");
}

export function extractText(html) {
  const tempElement = document.createElement("div");
  tempElement.innerHTML = html;
  return tempElement.textContent || tempElement.innerText || "";
}

// Convert any <h1> in body content to <h2>
export function normalizeBodyHeadings(html) {
  if (!html) return html;

  return html
    .replace(/<h1(\s[^>]*)?>/gi, "<h2$1>")
    .replace(/<\/h1>/gi, "</h2>");
}
